module.exports = __webpack_public_path__ + "static/media/uz.ca461bb1.svg";